import React, { useRef, useMemo } from 'react';
import { Marker } from 'react-leaflet';
import L from 'leaflet';

/**
 * Composant pour un marqueur déplaçable
 */
function DraggableMarker({ position, index, onDragEnd, isStart, isEnd }) {
    const markerRef = useRef(null);

    // Créer des icônes personnalisées pour différencier départ/arrivée/waypoint
    const customIcon = useMemo(() => {
        let iconHtml = '';
        let className = 'custom-marker';

        if (isStart) {
            iconHtml = `
        <div style="
          background: #22c55e;
          width: 32px;
          height: 32px;
          border-radius: 50% 50% 50% 0;
          transform: rotate(-45deg);
          border: 3px solid white;
          box-shadow: 0 3px 8px rgba(0,0,0,0.3);
          display: flex;
          align-items: center;
          justify-content: center;
        ">
          <span style="
            transform: rotate(45deg);
            color: white;
            font-weight: bold;
            font-size: 16px;
          ">A</span>
        </div>
      `;
            className = 'marker-start';
        } else if (isEnd) {
            iconHtml = `
        <div style="
          background: #ef4444;
          width: 32px;
          height: 32px;
          border-radius: 50% 50% 50% 0;
          transform: rotate(-45deg);
          border: 3px solid white;
          box-shadow: 0 3px 8px rgba(0,0,0,0.3);
          display: flex;
          align-items: center;
          justify-content: center;
        ">
          <span style="
            transform: rotate(45deg);
            color: white;
            font-weight: bold;
            font-size: 16px;
          ">B</span>
        </div>
      `;
            className = 'marker-end';
        } else {
            iconHtml = `
        <div style="
          background: #3b82f6;
          width: 24px;
          height: 24px;
          border-radius: 50%;
          border: 3px solid white;
          box-shadow: 0 2px 6px rgba(0,0,0,0.3);
          display: flex;
          align-items: center;
          justify-content: center;
        ">
          <span style="
            color: white;
            font-weight: bold;
            font-size: 12px;
          ">${index + 1}</span>
        </div>
      `;
            className = 'marker-waypoint';
        }

        return L.divIcon({
            html: iconHtml,
            className: className,
            iconSize: [32, 32],
            iconAnchor: [16, 32],
        });
    }, [isStart, isEnd, index]);

    const eventHandlers = useMemo(
        () => ({
            dragend() {
                const marker = markerRef.current;
                if (marker != null) {
                    const newPos = marker.getLatLng();
                    onDragEnd(index, [newPos.lat, newPos.lng]);
                }
            },
        }),
        [index, onDragEnd]
    );

    return (
        <Marker
            draggable={true}
            eventHandlers={eventHandlers}
            position={position}
            ref={markerRef}
            icon={customIcon}
        />
    );
}

export default DraggableMarker;